module.exports = __webpack_public_path__ + "media/2.8de618c4.mp3";